import React, {useRef} from 'react';
import {useField} from 'react-final-form';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import {useLocalStorage} from 'coreHooks';

import Field, {formatRule} from 'brandComponents/Form/Subcomponents/Field';
import PasswordToggle from 'brandComponents/Form/Subcomponents/PasswordToggle';
import {INPUT_MAX_LENGTH} from 'brandConstants';
import usePasswordLoop from 'brandHooks/usePasswordLoop';

import {IAuthLoginFormCredentialsProps} from './IAuthLoginFormCredentials';
import messages from './messages';

import styles from './AuthLoginFormCredentials.module.scss';

const AuthLoginFormCredentials = ({classNames, schema}: IAuthLoginFormCredentialsProps) => {
	const [passwordType, togglePasswordType] = usePasswordLoop();
	const [localStorageEmail] = useLocalStorage<string>('login-flyout_email', '');
	const intl = useIntl();

	const {meta: emailMeta} = useField('email', {
		subscription: {touched: true, error: true},
	});

	const {meta: passwordMeta} = useField('password', {
		subscription: {touched: true, error: true},
	});

	const hasEmailError = emailMeta.touched && emailMeta.error;
	const hasPasswordError = passwordMeta.touched && passwordMeta.error;

	const emailRef = useRef(null);

	return (
		<div className={cn(styles['auth__login-form__credentials'], classNames)}>
			<Field
				component="input"
				id="login-email"
				name="email"
				type="email"
				label={intl.formatMessage(messages.emailLabel)}
				classNamesCntr={cn({['has-error']: hasEmailError})}
				validation={schema.rules.email.map(formatRule(intl))}
				maxLength={INPUT_MAX_LENGTH}
				initialValue={localStorageEmail}
				autoComplete="email"
				requirednessLabel="*"
				ref={emailRef}
			/>

			<Field
				component="input"
				id="login-password"
				name="password"
				type={passwordType}
				label={intl.formatMessage(messages.passwordLabel)}
				customIcon={<PasswordToggle value={passwordType} onClick={togglePasswordType} />}
				classNamesCntr={cn({['has-error']: hasPasswordError})}
				validation={schema.rules.password.map(formatRule(intl))}
				requirednessLabel="*"
			/>
		</div>
	);
};

export default AuthLoginFormCredentials;
